import { Link } from "react-router-dom";
import type { Article } from "@/types/content";
import { formatCount, getCategoryStyle } from "@/utils/format";
import { categories } from "@/mocks/categories";

interface HotRankingListProps {
  articles: Article[];
  limit?: number;
  title?: string;
}

function categoryName(slug: string) {
  return categories.find((item) => item.slug === slug)?.name ?? "热瓜";
}

export default function HotRankingList({
  articles,
  limit = 6,
  title = "今日热榜",
}: HotRankingListProps) {
  const ranked = [...articles].sort((a, b) => b.hot - a.hot).slice(0, limit);

  return (
    <aside className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
      <div className="flex items-center justify-between px-4 md:px-5 py-4 border-b border-background-200 bg-primary-50">
        <h3 className="font-bold text-foreground-950 flex items-center gap-2">
          <span className="w-7 h-7 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-fire-line" aria-hidden="true"></i>
          </span>
          {title}
        </h3>
        <span className="text-[11px] text-primary-600">实时更新</span>
      </div>
      <ol className="divide-y divide-background-100">
        {ranked.map((article, index) => {
          const style = getCategoryStyle(article.category);
          const rank = index + 1;
          return (
            <li key={article.id}>
              <Link
                to={`/article/${article.id}`}
                className="flex items-start gap-3 px-4 md:px-5 py-3.5 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span
                  className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-xs font-bold ${
                    rank <= 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-500"
                  }`}
                >
                  {rank}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm text-foreground-800 leading-snug line-clamp-2">
                    {article.title}
                  </span>
                  <span className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-400">
                    <span className={style.text}>{categoryName(article.category)}</span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-fire-line" aria-hidden="true"></i>
                      {formatCount(article.hot)}
                    </span>
                  </span>
                </span>
              </Link>
            </li>
          );
        })}
      </ol>
      <div className="px-4 md:px-5 py-3 border-t border-background-200">
        <Link
          to="/category/entertainment"
          className="text-xs text-primary-600 hover:text-primary-700 inline-flex items-center gap-1 cursor-pointer whitespace-nowrap"
        >
          查看全部瓜田
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </aside>
  );
}